(function ($) {

    function init_add_review_product() {
        $(".add-review-product").off().on("click", function (e) {
            const context = $(this).data("modal-context")
            if (!context || !context.order_item_id){
                return
            }

            let rating
            const star = $(e.target).closest('svg')
            if (star.length > 0) {
                rating = star.prevAll(".stars").length + 1
            }
            else {
                rating = 0
            }

            gp_ajax({
                url: ghostpress_params.ajax_url + "&action=product_variant_rating",
                type: "post",
                dataType: "json",
                data: {
                    order_item_id: context.order_item_id,
                    rating: rating,
                },
                show_loading: true
            })
                .done(function (response) {
                    $(document).trigger(
                        'open_modal',
                        [
                            'my-account-product-review',
                            {
                                order_item_id: context.order_item_id,
                                review_id: response.data.review_id ?? "",
                            },
                            true
                        ]
                    )
                })
        })
    }

    $(document).gp_ready(init_add_review_product)

})(jQuery);